const actions = {
    INVENTORY_SET_EDIT_LINE: 'INVENTORY_SET_EDIT_LINE',
    INVENTORY_EDIT_PREV_LINE: 'INVENTORY_EDIT_PREV_LINE',
    INVENTORY_EDIT_NEXT_LINE: 'INVENTORY_EDIT_NEXT_LINE',
    INVENTORY_SET_FOCUSED_ELEMENT: 'INVENTORY_SET_FOCUSED_ELEMENT',
    INVENTORY_SET_ITEMS: 'INVENTORY_SET_ITEMS',
    INVENTORY_SET_ITEM: 'INVENTORY_SET_ITEM',
    INVENTORY_ADD_ITEM: 'INVENTORY_ADD_ITEM',
    INVENTORY_ADD_ITEMS: 'INVENTORY_ADD_ITEMS',
    INVENTORY_REMOVE_ITEM: 'INVENTORY_REMOVE_ITEM',

    setEditLine: line => ({
        type: actions.INVENTORY_SET_EDIT_LINE,
        line,
    }),
    editPrevLine: () => ({
        type: actions.INVENTORY_EDIT_PREV_LINE,
    }),
    editNextLine: () => ({
        type: actions.INVENTORY_EDIT_NEXT_LINE,
    }),
    setFocusedElement: element => ({
        type: actions.INVENTORY_SET_FOCUSED_ELEMENT,
        element,
    }),
    setItems: items => ({
        type: actions.INVENTORY_SET_ITEMS,
        items,
    }),
    setItem: item => ({
        type: actions.INVENTORY_SET_ITEM,
        item,
    }),
    addItem: (item, editItem = false) => ({
        type: actions.INVENTORY_ADD_ITEM,
        item,
        editItem,
    }),
    addItems: items => ({
        type: actions.INVENTORY_ADD_ITEMS,
        items,
    }),
    removeItem: line => ({
        type: actions.INVENTORY_REMOVE_ITEM,
        line,
    }),
};
export default actions;
